import React, { useState } from "react";
import {Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, useDisclosure, Input} from "@nextui-org/react";
import axios from "axios";
import { users_uri } from "../../../../utils/url";
import { toast } from "react-toastify";

export default function UpdateModal({datas, callback}) {
  const {isOpen, onOpen, onOpenChange} = useDisclosure();
  const [data, setData] = useState({phone: datas.phone_no, deposit: datas.deposit});
  const [load, setLoad] = useState(false);

  const handlecall = () => {
    callback();
  }

  const submit = async() => {
    setLoad(true);
    try{
        const res = await axios.patch(users_uri+'/update', {phone: data.phone, deposit: data.deposit, id: datas.id});
        if(res.status === 200){
            toast.success("Амжилттай шинчиллээ");
            handlecall();
        }
        setLoad(false);
    }catch(err){
        setLoad(false);
        console.log(err);
    }
  }

  return (
    <>
      <Button size="sm" onPress={onOpen}>Засварлах</Button>
      <Modal isOpen={isOpen} onOpenChange={onOpenChange}>
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="flex flex-col gap-1">Хэрэглэгчийн мэдээлэл засварлах</ModalHeader>
              <ModalBody>
                <div>
                    <h1 className="text-sm font-bold font-Roboto mb-1">Утасны дугаар</h1>
                    <Input placeholder="" size="sm" value={data.phone} onChange={(e)=> setData({...data, phone: e.target.value})}/>

                    <h1 className="text-sm font-bold font-Roboto mb-1 mt-3">Дансны дугаар</h1>
                    <Input placeholder="" size="sm" value={data.deposit} onChange={(e)=> setData({...data, deposit: e.target.value})}/>
                </div>
              </ModalBody>
              <ModalFooter>
                <Button color="danger" variant="light" onPress={onClose}>
                  Close
                </Button>
                {
                    load?
                    <Button color="primary">
                        Уншиж байна ...
                    </Button>
                    :
                    <Button color="primary" onPress={submit}>
                        Шинэчлэх
                    </Button>
                }
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
}
